var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBandAid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.098L9.563 4.36a2.246 2.246 0 00-2.892.241L4.597 6.675a2.246 2.246 0 00-.238 2.895L6.098 12M6.098 12l-1.739 2.43a2.246 2.246 0 00.238 2.895l2.074 2.074a2.246 2.246 0 002.892.241L12 17.902M12 17.902l2.43 1.739a2.246 2.246 0 002.895-.238l2.074-2.074a2.246 2.246 0 00.241-2.892L17.902 12l1.737-2.437a2.246 2.246 0 00-.241-2.892l-2.074-2.074a2.245 2.245 0 00-2.894-.238L12 6.098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15.05a.04.04 0 01-.019-.004.057.057 0 01-.016-.011A.047.047 0 018.95 15a.04.04 0 01.004-.019.057.057 0 01.011-.016.057.057 0 01.016-.011.051.051 0 01.066.027.058.058 0 01.003.019.047.047 0 01-.015.035.057.057 0 01-.016.011.04.04 0 01-.019.004zM15 9.05a.047.047 0 01-.035-.015A.047.047 0 0114.95 9a.04.04 0 01.004-.019.05.05 0 01.066-.027.057.057 0 01.016.011c.005.005.008.01.011.016A.058.058 0 0115.05 9a.047.047 0 01-.015.035.057.057 0 01-.016.011.04.04 0 01-.019.004zM12.035 11.965a.05.05 0 11-.07.07.05.05 0 01.07-.07M9.035 11.965a.05.05 0 11-.07.07.05.05 0 01.07-.07M15.035 11.965a.05.05 0 11-.07.07.05.05 0 01.07-.07M12.035 14.965a.05.05 0 11-.07.07.05.05 0 01.07-.07M12.035 8.965a.05.05 0 11-.07.07.05.05 0 01.07-.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.035 14.965a.05.05 0 11-.07.07.05.05 0 01.07-.07M15.035 8.965a.05.05 0 11-.07.07.05.05 0 01.07-.07"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgBandAid;


//////////////////
// WEBPACK FOOTER
// ./src/icons/band-aid.svg
// module id = 726
// module chunks = 13